import Layout from 'components/Layout';
import {
  IRichTextContainer,
  RichTextContainer as RichTextSection,
} from 'containers/RichTextContainer';
import { graphql } from 'gatsby';
import React from 'react';
import { IContentWithImage } from 'utils/types';

const components: {
  RichTextSection: React.FC<IRichTextContainer>;
} = {
  RichTextSection,
};

type Props = {
  data: {
    content: {
      title: string;
      sections: {
        componentName: string;
        headline: string;
        description?: { description: string };
        slug: string;
        title?: string;
        listOfContentWithImages?: IContentWithImage[];
      }[];
    };
  };
};

export const termsOfUsePage = (props: Props) => {
  const { data } = props;
  const { content } = data;
  const { sections } = content;

  return (
    <Layout>
      {sections.map((section, i: number) => {
        // @ts-ignore
        if (components[section.componentName]) {
          return React.createElement(
            // @ts-ignore
            components[section.componentName],
            {
              content: section,
              key: `${section.componentName}-${i}`, // handles the case for duplicate section keys
            },
          );
        }
      })}
    </Layout>
  );
};

export default termsOfUsePage;

export const data = graphql`
  query {
    content: contentfulPage(pageId: { eq: "EHSTermsOfUse" }) {
      title
      sections {
        headline
        componentName
        slug
        backgroundColor
        description {
          description
        }
        richTextBody {
          raw
        }
      }
    }
  }
`;
